define([
    "jquery",
    "underscore",
    "marionette"
], function($, _, Marionette) {
    return Marionette.ItemView.extend({

        ui:{
            'filters': '.filter'
        },

        initialize: function(config){
            _.extend( this , config);
        },

        onAttach: function(){
        },

        getFiltersUrlParam: function(){

            var data = [];
            $(this.ui.filters).each(function(){
                data.push($(this).attr("name")+"="+$(this).val());
            });

            return data.join("&");
        },

        getFiltersDataArray: function(){

            var data = {};
            $(this.ui.filters).each(function(){
                data[$(this).attr("name")] = $(this).val();
            });

            return data;
        }
    });
});
